import React, {useEffect, useState} from 'react';
import {hot} from 'react-hot-loader';
import {getPageData} from '../../sources/CmsSource';
import {useGetPageData} from '../../actions/CmsActions';
import {SpotlightPage} from 'epic-ue-spotlight';
import {extractSlugLocale} from '@epic-core/localization';
import {getLocale} from '@epic-core/common';
import {useStore} from '../../stores';
import styled from 'styled-components';
import {useSharedValue} from '@epic-core/hooks';
import {AppSharedKeys} from 'epic-ue-shared';
import {feedApi} from 'epic-ue-feed';

interface Properties {
    location: any;
}

const SpotlightWrap = styled.div`
    .article-tags {
        display: none;
    }
`;

let loadingPage = false;

const NewsDetailView = ({location = {}}: Properties) => {
    const pathname = location.pathname || '';
    const {pageSlug} = extractSlugLocale(pathname, getLocale());
    const [store] = useStore();
    const loading = store.loading || false;
    const currentPageData = useGetPageData({cmsUrlPattern: pageSlug});
    const [pageData, setPageData] = useState(currentPageData);
    const [latestFeedItemsStore, setLatestFeedItemsStore] = useSharedValue(AppSharedKeys.FeedItemsLatestStore);
    if ((!latestFeedItemsStore || !latestFeedItemsStore.items || !latestFeedItemsStore.items.length) && store.feedItems) {
        setLatestFeedItemsStore(store.feedItems);
    }

    const pageMatch = pageData && pageSlug === pageData._urlPattern;

    useEffect(() => {
        if (pageMatch || loadingPage) return;
        async function fetchData() {
            loadingPage = true;
            const newPageData = await getPageData(pageSlug);
            loadingPage = false;
            setPageData(newPageData);
        }
        fetchData();
    }, [pageMatch, pageSlug, setPageData]);

    return (
        <SpotlightWrap>
            <SpotlightPage pageData={pageData || {}} cmsLoading={loading || !pageMatch} urlPattern={pageSlug} />
        </SpotlightWrap>
    );
};

NewsDetailView.getInitialProps = async (match, {locale}, requestedUrl) => {
    const {pageSlug} = extractSlugLocale(requestedUrl, getLocale());

    let rawPageData = {};
    let feedItems = {};
    try {
        rawPageData = await getPageData(pageSlug);
        feedItems = (await feedApi.getFeedItems({})) || {};
    } catch (e) {
        console.error('NewsDetailView failed to load on the server', pageSlug);
        console.error(e.message);
    }

    //must match structure of StoreProvider
    return {
        cms: {
            [pageSlug]: rawPageData
        },
        feedItems
    };
};

export default hot(module)(NewsDetailView);
